<ng-container>
  <c-container [fluid]="true">
    <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId"
      class="ps-1">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-none d-lg-flex me-auto">

    </c-header-nav>

    <c-header-nav class="d-none d-lg-flex">

    </c-header-nav>
    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>

  </c-container>


</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">

    <button cButton color="" [caret]="false" cDropdownToggle class="py-0">
      <b> {{username?.user_name}} </b>
      <c-avatar cTextColor="primary" shape="rounded-1" size="md"
        src="assets/img/logo/LOGO.png" status="success">
      </c-avatar>
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">

      <!-- <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2">Settings</h6>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg> Password Change
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li> -->
      <li>
        <a (click)="profileEdit('edit',username)" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg> Profile
        </a>
      </li>

      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a routerLink="./" (click)="logout()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg> Logout
        </a>
      </li>
      <li></li>
    </ul>
  </c-dropdown>
</ng-template>
